'use strict';

var options4Ctrl = ['$uibModal', "$translate", "dialog", "$timeout", function ($uibModal, $translate, dialog, $timeout) {
    var _this = this;
    _this.editMode = [];
    _this.options = _this.options || [];

    _this.addOptionFromModal = function (newValue, edit, index) {
        _this.options = _this.options || [];
        
        // newValue format "referencia|#color"
        const parts = newValue.split('|');
        const reference = parts[0];
        const color = parts[1];
        
        if (!reference || reference.trim() === '') {
            this.errorMessage(
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_INVALID_REF_TITLE'),
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_INVALID_REF_BODY')
            );
            return;
        }
        
        const isValidColor = /^#[0-9A-Fa-f]{6}$/.test(color);
        if (!isValidColor) {
            this.errorMessage(
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_INVALID_COLOR_TITLE'),
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_INVALID_COLOR_BODY')
            );
            return;
        }
        
        const value = newValue.toLowerCase();
        
        if (edit) {
            const existingIndex = _this.options?.findIndex(elem => 
                elem.toLowerCase().split('|')[0] === reference.toLowerCase()
            );
            
            if (existingIndex !== -1 && existingIndex !== index) {
                this.errorMessage(
                    $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_DUPLICATE_REF_TITLE'),
                    $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_DUPLICATE_REF_BODY')
                );
                return;
            }
            _this.options[index] = value;
        } else {
            const exists = _this.options.find(elem => 
                elem.toLowerCase().split('|')[0] === reference.toLowerCase()
            );
            
            if (exists) {
                this.errorMessage(
                    $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_DUPLICATE_REF_TITLE'),
                    $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_DUPLICATE_REF_BODY')
                );
                return;
            }
            _this.options.push(value);
        }
        
        _this.newOption = null;
    };
    
    _this.edit = function (index) {
        _this.editMode[index] = true;
        this.openOptionList(_this.options, true, index);
        $timeout(function () {
            const ele = document.getElementById('chip_item_' + index);
            ele.focus();
        }, 100);
    }

    _this.copyOptions = function () {
        const jsonObject = {};
        _this.options.forEach(function(option) {
            const parts = option.split('|');
            const reference = parts[0];
            const color = parts[1];
            jsonObject[reference] = color;
        });
        
        const copyElement = document.createElement("textarea");
        copyElement.style.position = 'fixed';
        copyElement.style.opacity = '0';
        copyElement.textContent = JSON.stringify(jsonObject, null, 2);
        const body = document.getElementsByTagName('body')[0];
        body.appendChild(copyElement);
        copyElement.select();
        document.execCommand('copy');
        body.removeChild(copyElement);
    };

    _this.pasteOptions = function () {
        if (!navigator.clipboard || !navigator.clipboard.readText) {
            _this.errorMessage(
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_CLIPBOARD_UNAVAILABLE_TITLE'),
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_CLIPBOARD_UNAVAILABLE_BODY')
            );
            return;
        }

        navigator.clipboard.readText().then(function (clipboardText) {
            let parsedData;
            let parsedOptions = [];
            let usedReferences = {};

            try {
                parsedData = JSON.parse(clipboardText);
            } catch (err) {
                _this.errorMessage(
                    $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_PASTE_INVALID_JSON_TITLE'),
                    $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_PASTE_INVALID_JSON_BODY')
                );
                return;
            }

            if (!parsedData || typeof parsedData !== 'object' || Array.isArray(parsedData)) {
                _this.errorMessage(
                    $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_PASTE_INVALID_SHAPE_TITLE'),
                    $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_PASTE_INVALID_SHAPE_BODY')
                );
                return;
            }

            Object.keys(parsedData).forEach(function (reference) {
                let rawReference = (reference || '').trim();
                let color = parsedData[reference];

                if (!rawReference || typeof color !== 'string') {
                    return;
                }

                let normalizedReference = rawReference.toLowerCase();
                let normalizedColor = color.trim().toUpperCase();
                let isValidColor = /^#[0-9A-Fa-f]{6}$/.test(normalizedColor);

                if (!isValidColor || usedReferences[normalizedReference]) {
                    return;
                }

                usedReferences[normalizedReference] = true;
                parsedOptions.push(normalizedReference + '|' + normalizedColor);
            });

            if (parsedOptions.length === 0) {
                _this.errorMessage(
                    $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_PASTE_NO_VALID_TITLE'),
                    $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_PASTE_NO_VALID_BODY')
                );
                return;
            }

            $timeout(function () {
                _this.options = parsedOptions;
            });
        }).catch(function () {
            _this.errorMessage(
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_PASTE_READ_FAILED_TITLE'),
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_PASTE_READ_FAILED_BODY')
            );
        });
    };

    _this.removeChip = function (index) {
        _this.options.splice(index, 1);
    };

    _this.removeAll = function () {
        _this.options = [];
    };

    this.errorMessage = function(title, error) {
        dialog.alert({
            title: title,
            body: error,
            close: $translate.instant("DASHBOARD.CLOSE"),
            size: 'md'
        });
    }

    // MODAL
    this.openOptionList = function (options, edit, index) {
        $uibModal.open({
            animation: true,
            templateUrl: 'dashboard-graphBuilder/optionsColorModal.html',
            controller: [
                "$uibModalInstance",
                "toast",
                "options",
                "edit",
                "index",
                "$translate",
                function ($uibModalInstance, toast, options, edit, index, $translate) {
                    var _this = this;
                    this.edit = edit;
                    this.index = index;
                    this.options = options || [];
                    
                    if (this.edit && this.options[this.index]) {
                        const value = this.options[this.index];
                        const parts = value.split('|');
                        this.reference = parts[0];
                        this.colour = parts[1];
                    } else {
                        this.reference = '';
                        this.colour = '#C8E6C9';
                    }
                    
                    this.selectColor = function(color) {
                        this.colour = color;
                    };
                    
                    this.confirm = function() {
                        if (!this.reference || this.reference.trim() === '') {
                            toast.error($translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_MODAL_REFERENCE_REQUIRED'));
                            return;
                        }
                        
                        const isValidColor = /^#[0-9A-Fa-f]{6}$/.test(this.colour);
                        if (!isValidColor) {
                            toast.error($translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_MODAL_COLOR_INVALID'));
                            return;
                        }
                        
                        const value = this.reference.trim() + '|' + this.colour.toUpperCase();
                        const referenceLower = this.reference.trim().toLowerCase();
                        
                        const existingIndex = _this.options.findIndex(option => 
                            option.toLowerCase().split('|')[0] === referenceLower
                        );
                        
                        const isDuplicate = existingIndex !== -1 && 
                            (!_this.edit || (_this.edit && existingIndex !== _this.index));
                        
                        if (isDuplicate) {
                            toast.error($translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_REF_COLOR.ERR_MODAL_DUPLICATE_REFERENCE'));
                            return;
                        }
                        
                        $uibModalInstance.close({ 
                            value: value, 
                            edit: _this.edit, 
                            index: _this.index 
                        });
                    }

                    this.close = function () {
                        $uibModalInstance.close();
                    };
                },
            ],
            controllerAs: "ctrl",
            size: "md",
            windowClass: "color-modal-centered dialog", 
            bindToController: true,
            resolve: {
                options: function() {
                    return options;
                },
                edit: function() {
                    return edit;
                },
                index: function() {
                    return index;
                }
            }
        }).result.then((result) => {
            const { value, edit, index } = result || {};
            if (value) {
                _this.addOptionFromModal(value, edit, index);
            }
        }, function() { //dismiss
        });
    };
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            options: '=',
            hidehelp:'=',
            legend: '@',
            help: '@'
        },
        replace: true,
        controller: options4Ctrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-graphBuilder/options4Directive.html'
    };
};
